/**
 * Configuration for Permitting SAAS UI
 *
 * Production values are hardcoded for CI/CD builds.
 * These can be overridden via environment variables for local development.
 */

export const config = {
  // API Gateway endpoint
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT || 'https://buq789ejs2.execute-api.us-east-1.amazonaws.com/prod',

  // Cognito configuration
  cognito: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_k3SxJjkd2',
    userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '211esir10eogrtpievris2f5re',
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    domain: process.env.REACT_APP_COGNITO_DOMAIN || 'data-pipeline-permitting-prod.auth.us-east-1.amazoncognito.com',
  },

  // Stripe publishable key (live key - safe to commit as it's client-side)
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51T6IDqRC6DJRiJxvpQxJqAJznmsi5EpuxI7Diw7RZEvCcBXeY9iwEBOep805sa04oK2LPWrlFrKQMXNDY73GORyv007orG1vfT',
};
